import React, { useMemo } from "react";
import ReactDOM from "react-dom";

import { useClickOutside } from "../../hooks";
import Cross from "../../assets/svg/Cross";

import styles from "./Modal.module.scss";

const Modal = ({ children, className, close }) => {
  const closeModal = () => {
    close(false);
  };

  const root = useMemo(() => document.getElementById("modal-root"), []);

  const ref = useClickOutside(closeModal);

  return !!root ? (
    ReactDOM.createPortal(
      <div className={styles.Modal}>
        <div
          className={styles.Substrate}
          aria-label="Закрыть окно списка городов"
        >
          <div className="wrap holder no-pdn-top">
            <div className={styles.Container}>
              <button className={styles.Button} aria-label="X">
                <Cross className={styles.Icon} />
              </button>

              <div className={className}>
                <div className={styles.Wrapper} ref={ref}>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      root
    )
  ) : (
    <></>
  );
};

export default Modal;
